import Switch from "@mui/material/Switch";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import ActionsMenu from "../../components/Table/ActionsMenu";
import { IFiles } from "./types";
import { ContinerSwitch } from "../Channels/Channels/styles";
import { Spinner } from "../../components/Spinner";

interface IRow {
  Icon?: string;       
  iconUrl?: string;    
  name: string;
  categoryName: string;    
  Id: string;
  active: boolean;
}

/**
 * @param toggleIsEdit  
 * @param deleteHotelChain 
 * @param onDownload     
 * @param exist         
 * @param toggleStatus   
 * @param togglingId     
 */
export function getColumns(
  toggleIsEdit?: ((row: IFiles) => void) | null,
  deleteHotelChain?: ((row: IFiles) => void) | null,
  onDownload?: ((row: IFiles) => void) | null,
  exist?: boolean,
  toggleStatus?: ((row: { Active: boolean; Id: string }) => void) | null,
  togglingId?: string | null
) {
  const columns = [
    // {
    //   name: "Ícone",
      
    //   selector: (row: IRow) => {
    //     const iconSrc = row.iconUrl || row.Icon;
    //     if (!iconSrc) return null;
    //     return (
    //       <img
    //         src={iconSrc}
    //         alt="Ícone"
    //         style={{ width: 32, height: 32, objectFit: "contain" }}
    //       />
    //     );
    //   },
    //   width: "100px",
    // },
    {
      name: "Nome do grupo",
      selector: (row: IRow) => <span>{row.name}</span>,
    },
    {
      name: "Categoria",
      selector: (row: IRow) => (
        <span>{row.categoryName ? row.categoryName : "Não Informada"}</span>
      ),
    },
    {
      name: "Status",
      selector: (row: IRow) => {
        const handleChange = async () => {
          if (toggleStatus) {
            await toggleStatus({ Id: row.Id, Active: row.active });
          }
        };

        return (
          <ContinerSwitch>
            <FormGroup>
              <FormControlLabel
                control={
                  togglingId === row.Id ? (
                    <Spinner />
                  ) : (
                    <Switch
                      checked={row.active}
                      edge="start"
                      onChange={handleChange}
                    />
                  )
                }
                label={togglingId === row.Id ? "" : row.active ? "Ativo" : "Inativo"}
              />
            </FormGroup>
          </ContinerSwitch>
        );
      },
    },
    {
      width: "60px",
      cell: (row: IFiles) => (
        <ActionsMenu
          onEdit={toggleIsEdit ? () => toggleIsEdit(row) : null}
          onDownload={onDownload ? () => onDownload(row) : null}
          onDelete={deleteHotelChain ? () => deleteHotelChain(row) : null}
        />
      ),
    },
  ];

  if (exist) {
    columns.splice(2, 0, {
      name: "Status",
      selector: (row: IRow) => (
        <FormGroup>
          {row.active ? (
            <FormControlLabel control={<Switch defaultChecked />} label="Ativo" disabled />
          ) : (
            <FormControlLabel control={<Switch />} label="Inativo" disabled />
          )}
        </FormGroup>
      ),
    });
  }

  return columns;
}
